import { defineMessages } from "react-intl";

const messages = defineMessages({
  date: {
    id: "riskManagement.components.instrument.summary.date",
    defaultMessage: "Date",
  },
  slice: {
    id: "riskManagement.components.instrument.summary.sliceId",
    defaultMessage: "Slice",
  },
  value: {
    id: "riskManagement.components.instrument.summary.value",
    defaultMessage: "Value",
  },
  change: {
    id: "riskManagement.components.instrument.summary.change",
    defaultMessage: "Change",
  },
  priorSliceChange: {
    id: "riskManagement.components.instrument.summary.changeFromPriorSlice",
    defaultMessage: "Prior Slice Change",
  },
  range: {
    id: "riskManagement.components.instrument.summary.range",
    defaultMessage: "Range",
  },
  high: {
    id: "riskManagement.components.instrument.summary.range.high",
    defaultMessage: "High",
  },
  low: {
    id: "riskManagement.components.instrument.summary.range.low",
    defaultMessage: "Low",
  },
  errorHeader: {
    id: "riskManagement.components.instrument.summary.error.header",
    defaultMessage: "Error: Instrument summary is currently unavailable",
  },
});

export default messages;
